
export const EDUCATION_OPTIONS = [
  // Keep existing options
  { value: 'completed10th', label: 'Completed 10th Grade' },
  { value: 'completed12th', label: 'Completed 12th Grade' },
  
  // Bachelor's Degrees
  { value: 'ba', label: 'Bachelor of Arts (BA)' },
  { value: 'bsc', label: 'Bachelor of Science (BSc)' },
  { value: 'bcom', label: 'Bachelor of Commerce (BCom)' },
  { value: 'bba', label: 'Bachelor of Business Administration (BBA)' },
  { value: 'btech', label: 'Bachelor of Technology (BTech)' },
  { value: 'be', label: 'Bachelor of Engineering (BE)' },
  { value: 'barch', label: 'Bachelor of Architecture (BArch)' },
  { value: 'bpharm', label: 'Bachelor of Pharmacy (BPharm)' },
  { value: 'llb', label: 'Bachelor of Law (LLB)' },
  { value: 'bca', label: 'Bachelor of Computer Applications (BCA)' },
  { value: 'bfsc', label: 'Bachelor of Fisheries Science (BFSc)' },
  { value: 'bhm', label: 'Bachelor of Hotel Management (BHM)' },
  
  // Master's Degrees
  { value: 'ma', label: 'Master of Arts (MA)' },
  { value: 'msc', label: 'Master of Science (MSc)' },
  { value: 'mcom', label: 'Master of Commerce (MCom)' },
  { value: 'mba', label: 'Master of Business Administration (MBA)' },
  { value: 'mtech', label: 'Master of Technology (MTech)' },
  { value: 'me', label: 'Master of Engineering (ME)' },
  { value: 'march', label: 'Master of Architecture (MArch)' },
  { value: 'mpharm', label: 'Master of Pharmacy (MPharm)' },
  { value: 'llm', label: 'Master of Law (LLM)' },
  { value: 'mca', label: 'Master of Computer Applications (MCA)' },
  
  // Medical Degrees
  { value: 'mbbs', label: 'Bachelor of Medicine and Bachelor of Surgery (MBBS)' },
  { value: 'bds', label: 'Bachelor of Dental Surgery (BDS)' },
  { value: 'md', label: 'Doctor of Medicine (MD)' },
  { value: 'ms', label: 'Master of Surgery (MS)' },
  
  // Doctoral Degrees
  { value: 'phd', label: 'Doctor of Philosophy (PhD)' },
  
  // Diplomas and Certificates
  { value: 'diploma', label: 'Diploma (General)' },
  { value: 'pgdiploma', label: 'Post Graduate Diploma' },
  { value: 'certificate', label: 'Certificate Course' },
  { value: 'iti', label: 'Industrial Training Institute (ITI)' },
  
  // Professional Certifications
  { value: 'ca', label: 'Chartered Accountant (CA)' },
  { value: 'cs', label: 'Company Secretary (CS)' },
  { value: 'cma', label: 'Cost and Management Accountant (CMA)' },
  
  // Others
  { value: 'others', label: 'Others' }
];

// New limited education options for the signup form
export const BASIC_EDUCATION_OPTIONS = [
  { value: 'completed10th', label: 'Completed 10th Grade' },
  { value: 'completed12th', label: 'Completed 12th Grade' }
];
